import { useEffect, useState } from "react";

/**
 * Custom hook to manage extra details display preferences
 * @returns {Object} - Object containing showExtraDetails state and toggle function
 */
export const useExtraDetails = () => {
  const [showExtraDetails, setShowExtraDetails] = useState(false);

  // Initialize from localStorage on mount
  useEffect(() => {
    const savedPreference = localStorage.getItem("showExtraDetails");
    if (savedPreference !== null) {
      setShowExtraDetails(savedPreference === "true");
    }
  }, []);

  // Set up event listener for changes from other components
  useEffect(() => {
    const handleExtraDetailsChange = () => {
      const updatedPreference = localStorage.getItem("showExtraDetails");
      setShowExtraDetails(updatedPreference === "true");
    };

    window.addEventListener("extraDetailsChanged", handleExtraDetailsChange);
    window.addEventListener("storage", (e) => {
      if (e.key === "showExtraDetails") {
        handleExtraDetailsChange();
      }
    });

    return () => {
      window.removeEventListener(
        "extraDetailsChanged",
        handleExtraDetailsChange,
      );
      window.removeEventListener("storage", handleExtraDetailsChange);
    };
  }, []);

  // Function to toggle extra details display preference
  const toggleExtraDetails = (checked) => {
    setShowExtraDetails(checked);
    localStorage.setItem("showExtraDetails", checked);

    // Dispatch an event so other components can react to this change
    window.dispatchEvent(new Event("extraDetailsChanged"));
  };

  return {
    showExtraDetails,
    toggleExtraDetails,
  };
};
